import { render, staticRenderFns } from "./FormOne.vue?vue&type=template&id=70053228&scoped=true"
import script from "./FormOne.vue?vue&type=script&lang=js"
export * from "./FormOne.vue?vue&type=script&lang=js"
import style0 from "./FormOne.vue?vue&type=style&index=0&id=70053228&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70053228",
  null
  
)

export default component.exports